import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Trip from '../../components/Trip/Trip';
import TripsList from '../../components/TripsList/TripsList';

function Trips() {
  return (
    <Routes>
      <Route
        index
        element={<TripsList />}
      />
      <Route
        path=':tripId/*'
        element={<Trip />}
      />
    </Routes>
  );
}

Trips.displayName = 'Trips';
export default Trips;
